import { PaymentManagementContainer } from "../../Componant/organisms/PaymentManagement";

function PaymentManagement() {
  return (
    <div className="page-body">
      <PaymentManagementContainer />
    </div>
  );
}

export default PaymentManagement;
